import Lib from '../../../commons/lib';

export default class Service {
  static helyszinUrl = window.location.origin + '/api/helyszin/';

  static jegyTermekUrl = window.location.origin + "/api/jegytermek/";

  static raktarUrl = window.location.origin + '/api/raktar/';

  static telepulesUrl = window.location.origin + '/api/telepules/';

  static cegadatUrl = window.location.origin + '/api/cegadat/';

  // HELYSZÍN START

  static listHelyszin(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.helyszinUrl + 'helyszin/list',
      args: { requestType: 'helyszin-list' },
    }], fnDone);
  }

  static addHelyszin(helyszinObj, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.helyszinUrl + 'helyszin',
      args: { requestType: 'helyszin-post' },
      data: helyszinObj
    }], fnDone);
  }

  static modifyHelyszin(helyszinObj, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.helyszinUrl + 'helyszin',
      args: { requestType: 'helyszin-put' },
      data: helyszinObj
    }], fnDone);
  }

  static deleteHelyszin(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.helyszinUrl + 'helyszin',
      args: { requestType: 'helyszin-delete' },
      params: { id: id }
    }], fnDone);
  }

  static getHelyszin(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.helyszinUrl + 'helyszin',
      args: { requestType: 'helyszin-get' },
      params: { id: id }
    }], fnDone);
  }

  static viewHelyszin(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.helyszinUrl + 'helyszin/view',
      args: { requestType: 'helyszin-view' },
      params: { id: id }
    }], fnDone);
  }

  static initHelyszinForm(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.helyszinUrl + 'helyszin/init',
      args: { requestType: 'helyszin-get' },
      params: { id: id }
    }], fnDone);
  }

  static getAngolNyelv(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.helyszinUrl + 'helyszin/angolnyelv',
      args: { requestType: 'helyszin-angolnyelv-get' },
    }], fnDone);
  }

  // HELYSZÍN END

  // IMAGE START

  static listEditorImages(fnDone) {
    Lib.MicroServices.requestService([{
          method: "GET",
          url: Service.helyszinUrl + "editor/list",
          args: { requestType: "editor-list-get" }
        }], fnDone);
  }

  static uploadEditorImage(file, id, fnDone) {
    Lib.MicroServices.requestService([{
          method: "POST",
          url: Service.helyszinUrl + 'editor',
          args: { requestType: "editor-post" },
          params: { funkcioId: id },
          data: file
        }], fnDone);
  }

  static deleteEditorImages(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: "DELETE",
          url: Service.helyszinUrl + 'editor',
          args: { requestType: "editor-post" },
          params: { funkcioId: id },
        }
      ],
      fnDone
    );
  }

  static deleteEditorImage(id, imageName, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: "DELETE",
          url: Service.helyszinUrl + `editor/image/${imageName}`,
          args: { requestType: "editor-post" },
          params: { funkcioId: id },
        }
      ],
      fnDone
    );
  }

  // IMAGE END

  // TEREM START

  static listTeremAllapot(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.helyszinUrl + 'terem/init',
      args: { requestType: 'terem-allapot-get' },
    }], fnDone);
  }

  static listTerem(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.helyszinUrl + 'terem/list',
      args: { requestType: 'terem-list-get' },
    }], fnDone);
  }

  static viewTerem(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.helyszinUrl + 'terem/view',
      args: { requestType: 'terem-list-view' },
      params: { id: id }
    }], fnDone);
  }

  static getTerem(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.helyszinUrl + 'terem',
      args: { requestType: 'terem-get' },
      params: { id: id }
    }], fnDone);
  }

  static addTerem(teremObj, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.helyszinUrl + 'terem',
      args: { requestType: 'terem-post' },
      data: teremObj
    }], fnDone);
  }

  static modifyTerem(teremObj, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.helyszinUrl + 'terem',
      args: { requestType: 'terem-put' },
      data: teremObj
    }], fnDone);
  }

  static deleteTerem(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.helyszinUrl + 'terem',
      args: { requestType: 'terem-delete' },
      params: { id: id }
    }], fnDone);
  }

  // TEREM END

  // TEREMKIOSZTAS START

  static initTeremKiosztas(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: "GET",
          url: Service.jegyTermekUrl + "kiosztas/init",
          params: { id: id }
        }
      ],
      fnDone
    );
  }

  static getTeremkiosztas(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: "GET",
          url: Service.jegyTermekUrl + "kiosztas",
          params: { id: id }
        }
      ],
      fnDone
    );
  }

  static insertTeremkiosztas(kiosztas, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: "POST",
          url: Service.jegyTermekUrl + "kiosztas",
          data: kiosztas
        }
      ],
      fnDone
    );
  }

  static modifyTeremkiosztas(kiosztas, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: "PUT",
          url: Service.jegyTermekUrl + "kiosztas",
          data: kiosztas
        }
      ],
      fnDone
    );
  }

  static deleteTeremkiosztas(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: "DELETE",
          url: Service.jegyTermekUrl + "kiosztas",
          params: { id: id }
        }
      ],
      fnDone
    );
  }

  // TEREMKIOSZTAS END

  // SZEKTOR START

    static listSzektor(fnDone) {
      Lib.MicroServices.requestService(
        [
          {
            method: "GET",
            url: Service.jegyTermekUrl + "szektor/list"
          }
        ],
        fnDone
      );
    }
  
    static getSzektor(id, fnDone) {
      Lib.MicroServices.requestService(
        [
          {
            method: "GET",
            url: Service.jegyTermekUrl + "szektor",
            params: { id: id }
          }
        ],
        fnDone
      );
    }
  
    static addSzektor(szektor, fnDone) {
      Lib.MicroServices.requestService(
        [
          {
            method: "POST",
            url: Service.jegyTermekUrl + "szektor",
            data: szektor
          }
        ],
        fnDone
      );
    }
  
    static editSzektor(szektor, fnDone) {
      Lib.MicroServices.requestService(
        [
          {
            method: "PUT",
            url: Service.jegyTermekUrl + "szektor",
            data: szektor
          }
        ],
        fnDone
      );
    }
  
    static deleteSzektor(id, fnDone) {
      Lib.MicroServices.requestService(
        [
          {
            method: "DELETE",
            url: Service.jegyTermekUrl + "szektor",
            params: { id: id }
          }
        ],
        fnDone
      );
    }
  
  // SZEKTOR END

  // TELEPÜLÉS START

  static listOrszag(name, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.telepulesUrl + 'orszag/list',
      args: { requestType: 'telepules-orszag-list' },
      params: { name: name }
    }], fnDone);
  }

  static getOrszag(kod, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.telepulesUrl + 'orszag/kod',
      args: { requestType: 'telepules-orszag-get' },
      params: { kod: kod },
    }], fnDone);
  }

  static listCim(text, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.telepulesUrl + 'telepules/like',
      args: { requestType: 'telepules-get-listcim' },
      params: { text: text }
    }], fnDone);
  }

  // TELEPÜLÉS END

  // RAKTÁR START

  static listRaktar(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.raktarUrl + 'raktar/list',
      args: { requestType: 'raktar-list' },
    }], fnDone);
  }

  // RAKTÁR END


  // CÉGADAT START

  static listAktivCegadat(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.cegadatUrl + 'search',
      params: {
        aktiv: true,
        resultclass: '30'
      },
      data: [id]
    }], fnDone);
  }

  // CÉGADAT START

  // KÜLSŐ KLIENS TÖRZSADAT START

  static listKliens(fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.helyszinUrl + 'kulsokliens/list'
        }
      ],
      fnDone
    );
  }

  static initForm(fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.helyszinUrl + 'kulsokliens/initform'
        }
      ],
      fnDone
    );
  }

  static getKliens(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.helyszinUrl + 'kulsokliens',
          params: { id: id }
        }
      ],
      fnDone
    );
  }

  static addKliens(szektor, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'POST',
          url: Service.helyszinUrl + 'kulsokliens',
          data: szektor
        }
      ],
      fnDone
    );
  }

  static editKliens(szektor, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'PUT',
          url: Service.helyszinUrl + 'kulsokliens',
          data: szektor
        }
      ],
      fnDone
    );
  }

  static deleteKliens(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'DELETE',
          url: Service.helyszinUrl + 'kulsokliens',
          params: { id: id }
        }
      ],
      fnDone
    );
  }

  // KÜLSŐ KLIENS TÖRZSADAT END

  // KÜLSŐ KLIENS FUNCKIONALITÁS START

  static getTimeoutMs(fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.helyszinUrl + 'ws/timeout',
          args: { requestType: 'timeout-get' }
        }
      ],
      fnDone
    );
  }

  static getAd(fingerprint, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.helyszinUrl + 'wskliens/ad',
          args: { requestType: 'wskliens-ad' },
          header: {
            Fingerprint: fingerprint
          }
        }
      ],
      fnDone
    );
  }

  static deleteSession(sessionid, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'DELETE',
          url: Service.helyszinUrl + 'ws/kulsokliens/session',
          args: { requestType: 'session-delete' },
          params: { id: sessionid }
        }
      ],
      fnDone
    );
  }

  // KULSŐ KLIENS FUNCKIONALITÁS END

  // PUBLIKUS SZINSEMA START

  //getSzinAdatok

  static listPublikusSzin(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.helyszinUrl + 'publikusszin/list',
    },
    ], fnDone);
  }

  static getPublikusSzin(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.helyszinUrl + 'publikusszin',
      params: { id: id },
    },
    ], fnDone);
  }

  static insertPublikusSzin(szinsema, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.helyszinUrl + 'publikusszin',
      data: szinsema,
    },
    ], fnDone);
  }

  static modifyPublikusSzin(szinsema, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.helyszinUrl + 'publikusszin',
      data: szinsema,
    },
    ], fnDone);
  }

  static initPublikusSzinForm(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.helyszinUrl + 'publikusszin/init',
    },
    ], fnDone);
  }

  static deletePublikusSzin(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.helyszinUrl + 'publikusszin',
      params: { id: id },
    },
    ], fnDone);
  }

  // PUBLIKUS SZINSEMA END

}
